import { useEffect, useState } from "react";
import "./App.css";

import { Route, useLocation, Routes, Navigate } from "react-router-dom";

import Home from "./pages/Home";
import Menu from "./pages/Menu";
import Header from "./components/Header/Header";
import Footer from "./components/Footer/Footer";
import Promo from "./pages/Promo";
import SingleView from "./pages/SingleView";
import Login from "./components/Login/Login";
import Register from "./components/Register/Register";
import Cart from "./pages/Cart";
import Profile from "./pages/Profile";
import ScrollToTop from "./components/ScrollToTop/ScrollToTop";
import { getCurrentUser } from "./services/userService";
import { useCookies } from "react-cookie";
import Error from "./pages/404";
import { guestLogin } from "./services/auth";
import InfoMessage from "./components/InfoMessage/InfoMessage";
import CopyMessage from "./components/CopyMessage/InfoMessage";
import DeletedMessage from "./components/DeletedMessage/DeletedMessage";
import Feedback from "./components/Feedback/Feedback";
import TermsAndConditions from "./pages/Terms";
import ForgottenPassword from "./components/ForgottenPassword/ForgottenPassword";
import FloatingPhoneButton from "./components/FloatingPhoneButton/FloatingPhoneButton";
import Search from "./pages/Search";

const useQuery = () => {
  return new URLSearchParams(useLocation().search);
};

function AppLive() {
  return (
    <>
      <ScrollToTop />
      <AppContent />
    </>
  );
}

function AppContent() {
  const [cookie, setCookie] = useCookies(["access_token"]);
  const cartLocalStorage = JSON.parse(localStorage.getItem("cart") || "[]");
  const [cart, setCart] = useState(cartLocalStorage);
  const [user, setUser] = useState(null);
  const [activePage, setActivePage] = useState();
  const [openLogin, setOpenLogin] = useState(false);
  const [openRegister, setOpenRegister] = useState(false);
  const [openLogOut, setOpenLogOut] = useState(false);
  const [openBurger, setOpenBurger] = useState(false);
  const [openConfirmation, setOpenConfirmation] = useState(false);
  const [openDeliveryPopup, setOpenDeliveryPopup] = useState(false);
  const [active, setActive] = useState();
  const [loading, setLoading] = useState(false);

  const [showMessage, setShowMessage] = useState(false);
  const [showCopyMessage, setShowCopyMessage] = useState(false);
  const [showDeletedMessage, setShowDeletedMessage] = useState(false);
  const [showAllId, setShowAllId] = useState();

  const [isFeedbackOpen, setFeedbackOpen] = useState(false);
  const [isFeedbackSent, setIsFeedbackSent] = useState(false);
  const [feedbackOrderId, setFeedbackOrderId] = useState(null);
  const query = useQuery();

  useEffect(() => {
    const orderId = query.get("orderId");
    if (orderId) {
      setFeedbackOrderId(orderId);
      setFeedbackOpen(true);
    }
  }, [query]);

  const closeFeedback = () => {
    setFeedbackOpen(false);
    setIsFeedbackSent(true);
  };

  useEffect(() => {
    localStorage.getItem("activeMenu")
      ? setActive(localStorage.getItem("activeMenu"))
      : setActive(9);
  }, []);

  useEffect(() => {
    setLoading(true);
  }, [active]);

  useEffect(() => {
    activePage && localStorage.setItem("activePage", activePage);
  }, [activePage]);

  useEffect(() => {
    localStorage.setItem("cart", JSON.stringify(cart));
  }, [cart]);

  useEffect(() => {
    showAllId && localStorage.setItem("categoryId", showAllId);
  }, [showAllId]);

  useEffect(() => {
    localStorage?.getItem("categoryId") &&
      setShowAllId(localStorage.getItem("categoryId"));
    setActivePage(localStorage.getItem("activePage"));
  }, []);

  useEffect(() => {
    showMessage &&
      setTimeout(() => {
        setShowMessage(false);
      }, 4000);
  }, [showMessage]);

  useEffect(() => {
    showCopyMessage &&
      setTimeout(() => {
        setShowCopyMessage(false);
      }, 4000);
  }, [showCopyMessage]);

  useEffect(() => {
    showDeletedMessage &&
      setTimeout(() => {
        setShowDeletedMessage(false);
      }, 4000);
  }, [showDeletedMessage]);

  useEffect(() => {
    cookie?.access_token !== undefined
      ? getCurrentUser(cookie.access_token).then((res) => setUser(res))
      : guestLogin().then((res) =>
          setCookie("access_token", res?.data?.access_token, { path: "/" })
        );
  }, [cookie, setCookie]);

  useEffect(() => {
    if (
      openLogin ||
      openRegister ||
      openLogOut ||
      openConfirmation ||
      openDeliveryPopup ||
      (isFeedbackOpen && !isFeedbackSent)
    ) {
      document.documentElement.style.overflowY = "hidden";
    } else {
      document.documentElement.style.overflowY = "visible";
    }

    (openLogin ||
      openRegister ||
      openLogOut ||
      openConfirmation ||
      openDeliveryPopup ||
      (isFeedbackOpen && !isFeedbackSent)) &&
      setOpenBurger(false);
  }, [
    openLogin,
    openRegister,
    openLogOut,
    openConfirmation,
    openDeliveryPopup,
    isFeedbackOpen,
    isFeedbackSent,
  ]);

  function NavigateToPath() {
    const path = window.location.pathname;
    const newPath = path.replace("/app", "");
    return <Navigate to={`${newPath}`} replace />;
  }

  return (
    <div className="App">
      <Header
        activePage={activePage}
        setActivePage={setActivePage}
        openLogin={openLogin}
        setOpenLogin={setOpenLogin}
        openRegister={openRegister}
        setOpenRegister={setOpenRegister}
        openBurger={openBurger}
        setOpenBurger={setOpenBurger}
        user={user}
        setUser={setUser}
        cart={cart}
      />
      <FloatingPhoneButton />
      {showMessage && (
        <InfoMessage
          message={typeof showMessage === "string" ? showMessage : undefined}
        />
      )}
      {showCopyMessage && <CopyMessage />}
      {showDeletedMessage && <DeletedMessage />}
      <Routes>
        <Route path="/app/:path" element={<NavigateToPath />} />
        <Route path="/app" element={<Navigate to="/" replace />} />
        <Route
          index
          path="/"
          element={<Home active={active} setActive={setActive} />}
        />
        <Route
          path="/menu"
          element={
            <Menu
              cart={cart}
              setCart={setCart}
              active={active}
              setActive={setActive}
              showMessage={showMessage}
              setShowMessage={setShowMessage}
              loading={loading}
              setLoading={setLoading}
              showAllId={showAllId}
              setShowAllId={setShowAllId}
            />
          }
        />
        <Route
          path="/search"
          element={
            <Search
              cart={cart}
              setCart={setCart}
              active={active}
              setActive={setActive}
              showMessage={showMessage}
              setShowMessage={setShowMessage}
              loading={loading}
              setLoading={setLoading}
              showAllId={showAllId}
              setShowAllId={setShowAllId}
            />
          }
        />
        <Route
          path="/menu/category/:categoryId"
          element={
            <Menu
              cart={cart}
              setCart={setCart}
              active={active}
              setActive={setActive}
              showMessage={showMessage}
              setShowMessage={setShowMessage}
              loading={loading}
              setLoading={setLoading}
              showAllId={showAllId}
              setShowAllId={setShowAllId}
            />
          }
        />
        <Route
          path="/menu/category/:categoryId/subcategory/:subcategoryId"
          element={
            <Menu
              cart={cart}
              setCart={setCart}
              active={active}
              setActive={setActive}
              showMessage={showMessage}
              setShowMessage={setShowMessage}
              loading={loading}
              setLoading={setLoading}
              showAllId={showAllId}
              setShowAllId={setShowAllId}
            />
          }
        />
        <Route
          path="/menu/category/:categoryId/product/:productId"
          element={
            <SingleView
              cart={cart}
              setCart={setCart}
              showMessage={showMessage}
              setShowMessage={setShowMessage}
              showAllId={showAllId}
              setShowAllId={setShowAllId}
              setActive={setActive}
            />
          }
        />
        <Route
          path="/menu/product/:productId"
          element={
            <SingleView
              cart={cart}
              setCart={setCart}
              showMessage={showMessage}
              setShowMessage={setShowMessage}
              showAllId={showAllId}
              setShowAllId={setShowAllId}
              setActive={setActive}
            />
          }
        />
        <Route
          path="/menu/category/:categoryId/subcategory/:subcategoryId/product/:productId"
          element={
            <SingleView
              cart={cart}
              setCart={setCart}
              showMessage={showMessage}
              setShowMessage={setShowMessage}
              showAllId={showAllId}
              setShowAllId={setShowAllId}
              setActive={setActive}
            />
          }
        />
        <Route
          path="/promotions"
          element={<Promo cart={cart} setCart={setCart} />}
        />
        <Route
          path="/cart"
          element={
            <Cart
              openLogin={openLogin}
              setOpenLogin={setOpenLogin}
              cart={cart}
              setCart={setCart}
              user={user}
              setOpenConfirmation={setOpenConfirmation}
              setOpenBurger={setOpenBurger}
              showMessage={showMessage}
              setShowMessage={setShowMessage}
            />
          }
        />
        <Route
          path="/profile"
          element={
            <Profile
              openLogOut={openLogOut}
              setOpenLogOut={setOpenLogOut}
              user={user}
              setUser={setUser}
              setOpenBurger={setOpenBurger}
              cart={cart}
              setCart={setCart}
              setOpenLogin={setOpenLogin}
              showMessage={showMessage}
              setShowMessage={setShowMessage}
              showCopyMessage={showCopyMessage}
              setShowCopyMessage={setShowCopyMessage}
              showDeletedMessage={showDeletedMessage}
              setShowDeletedMessage={setShowDeletedMessage}
            />
          }
        />
        <Route path="404" element={<Error />} />
        <Route path="/terms" element={<TermsAndConditions />} />
        <Route path="/reset-password/:token" element={<ForgottenPassword />} />
        <Route path="*" element={<Error />} />
      </Routes>
      {(!user || user.isGuest) && openLogin && (
        <Login
          setOpenLogin={setOpenLogin}
          setOpenRegister={setOpenRegister}
          user={user}
          setUser={setUser}
        />
      )}
      {(!user || user.isGuest) && openRegister && (
        <Register
          setOpenLogin={setOpenLogin}
          setOpenRegister={setOpenRegister}
          user={user}
          setUser={setUser}
        />
      )}
      {isFeedbackOpen && !isFeedbackSent && (
        <Feedback
          orderId={feedbackOrderId}
          onClose={closeFeedback}
          setIsFeedbackSent={setIsFeedbackSent}
        />
      )}
      <Footer
        openDeliveryPopup={openDeliveryPopup}
        setOpenDeliveryPopup={setOpenDeliveryPopup}
      />
    </div>
  );
}

export default AppLive;
